import {
  createAppI18n,
  defaultLang,
  loadLocalTranslations,
  registerI18nInstance
} from '@shared/locales'

export const crmI18n = createAppI18n()

const initializeCrmI18n = async (lang: string) => {
  await loadLocalTranslations(crmI18n, 'crm', lang)
}

registerI18nInstance(crmI18n)

let lastLoadedLang: string | null = null

crmI18n.on('languageChanged', async (newLang) => {
  if (newLang !== lastLoadedLang) {
    await initializeCrmI18n(newLang)
    lastLoadedLang = newLang
  }
})

const initializeDefaultLanguage = async () => {
  const lang = crmI18n.language || defaultLang.value

  await initializeCrmI18n(lang)
}

initializeDefaultLanguage()
